import { useAppSelector } from '@/hooks';
import { Button, Stack, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddQuoteMutation } from '../organizations/api/quoteApi';
import { Contact as IContact } from '@/types/quote';

const initialValues = { name: '', email: '', message: '', phone: '' };

const Contact = () => {
  const navigate = useNavigate();
   const organizationId = useAppSelector((state) => state.ui.activeOrganization);
  const products = useAppSelector((state) => state.quote.items);
  const [addQuote, addQuoteMutation] = useAddQuoteMutation();

  const formik = useFormik({
    initialValues,
    onSubmit: async (contact: IContact) => {
      try {
        if (!organizationId) return;

        await addQuote({
          organizationId,
          payload: {
            contact,
            products,
          },
        });

        navigate('/cotizacion/gracias');
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    formik.setValues({
      ...formik.values,
      name: '',
      email: '',
      phone: '',
      message: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log('formik', formik.values);

  return (
    <Stack spacing={2} flex={1} padding={3}>
      <Stack spacing={2}>
        <TextField
          name="name"
          label="Nombre"
          size="small"
          value={formik.values.name}
          onChange={formik.handleChange}
        />
        <Stack spacing={2} direction={'row'}>
          <TextField
            name="phone"
            label="Teléfono"
            size="small"
            fullWidth
            value={formik.values.phone}
            onChange={formik.handleChange}
          />
          <TextField
            name="email"
            label="Correo"
            size="small"
            fullWidth
            value={formik.values.email}
            onChange={formik.handleChange}
          />
        </Stack>
        <TextField
          name="message"
          label="Comentarios"
          multiline
          rows={3}
          value={formik.values.message}
          onChange={formik.handleChange}
        />
      </Stack>
      <Stack spacing={2} direction={'row'}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Regresar
        </Button>
        <Button
          onClick={formik.handleSubmit}
          disabled={addQuoteMutation.isLoading}
        >
          Cotizar
        </Button>
      </Stack>
    </Stack>
  );
};

export default Contact;
